import { render, staticRenderFns } from "./DataCollectionList.vue?vue&type=template&id=ab886d12"
import script from "./DataCollectionList.vue?vue&type=script&lang=ts"
export * from "./DataCollectionList.vue?vue&type=script&lang=ts"
import style0 from "./DataCollectionList.vue?vue&type=style&index=0&id=ab886d12&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports